import {
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { DataStore } from "aws-amplify";
import { navigate } from "gatsby-link";
import React, { Fragment, useEffect, useState } from "react";
import MuiForm from "rjsf-material-ui";
import { Dataset, Status } from "../../api/models";
import AtlasPanel from "../../atlas/blades/AtlasPanel";

const DatasetAnalysis: React.FC<any> = ({
  theme,
  project,
  dataset,
  processes,
}) => {
  const [analysis, setAnalysis] = useState<any>(null);
  const [name, setName] = useState("");
  useEffect(() => {
    if (processes === null) return;
    processes.forEach((v, i) => {
      v.key = `v${i}`;
      v.formJson = JSON.parse(v.formJson);
    });
    if (processes.length > 0) {
      setAnalysis(processes[0]);
      setName(`${dataset.name} / ${processes[0].name}`);
    }
  }, [processes]);

  if (analysis === null) return <Fragment />;

  const onSubmit = async (e) => {
    const run = {
      status: Status.PENDING,
      name: name,
      desc: "",
      s3: "",
      sourceDatasets: [dataset.id],
      paramJson: JSON.stringify(e.formData),
      computeJson: JSON.stringify({
        io_limited: { cpus: 2, memory: "4.GB", maxRetries: 1 },
        io_net: { cpus: 2, memory: "4.GB", maxRetries: 1 },
        mem_medium: { cpus: 4, memory: "30.GB", maxRetries: 1 },
        mem_veryhigh: { cpus: 16, memory: "120.GB", maxRetries: 1 },
      }),
      infoJson: "",
      tags: [],
      administratorGroup: dataset.administratorGroup,
      contributorGroup: dataset.contributorGroup,
      collaboratorGroup: dataset.collaboratorGroup,
      process: analysis.id,
      projectRef: project,
    };

    const ds = new Dataset(run);
    const result = await DataStore.save(ds);
    document.location.href = `../../${result.id}/project/${project.id}`;
  };

  return (
    <AtlasPanel title="Pipelines">
      <Grid container spacing={10} style={{ fontSize: 13 }}>
        <Grid item xs={6}>
          <div className="portalLabel" style={{ paddingBottom: "20px" }}>
            Workflow Parameters
          </div>
          <FormControl fullWidth style={{ paddingBottom: "10px" }}>
            <InputLabel htmlFor="my-input">Name (Results Dataset)</InputLabel>
            <Input
              id="my-input"
              aria-describedby="my-helper-text"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="pipeline-label">Pipeline</InputLabel>
            <Select
              value={analysis.key}
              labelId="pipeline-label"
              id="pipeline"
              fullWidth
            >
              {processes.map((v, i) => (
                <MenuItem key={v.key} value={v.key}>
                  {v.name} - {v.desc}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <MuiForm
            style={{ fontSize: "14px" }}
            schema={analysis.formJson.form}
            uiSchema={analysis.formJson.ui}
            onSubmit={onSubmit}
          />
        </Grid>
        <Grid item xs={6}>
          <div className="portalLabel" style={{ paddingBottom: "20px" }}>
            Compute Profiles
          </div>
          <Grid container spacing={3} style={{ fontSize: 13 }}>
            <Grid item xs={3}>
              <div className="portalCopy" style={{ paddingBottom: "10px" }}>
                IO Limited
              </div>
              <TextField
                id="standard-number"
                label="CPUs"
                type="number"
                defaultValue="2"
              />
              <TextField
                id="standard-number"
                label="Memory (GB)"
                type="number"
                defaultValue="4"
              />
            </Grid>
            <Grid item xs={3}>
              <div className="portalCopy" style={{ paddingBottom: "10px" }}>
                IO Net
              </div>
              <TextField
                id="standard-number"
                label="CPUs"
                type="number"
                defaultValue="2"
              />
              <TextField
                id="standard-number"
                label="Memory (GB)"
                type="number"
                defaultValue="4"
              />
            </Grid>
            <Grid item xs={3}>
              <div className="portalCopy" style={{ paddingBottom: "10px" }}>
                Memory Medium
              </div>
              <TextField
                id="standard-number"
                label="CPUs"
                type="number"
                defaultValue="4"
              />
              <TextField
                id="standard-number"
                label="Memory (GB)"
                type="number"
                defaultValue="30"
              />
            </Grid>
            <Grid item xs={3}>
              <div className="portalCopy" style={{ paddingBottom: "10px" }}>
                Memory High
              </div>
              <TextField
                id="standard-number"
                label="CPUs"
                type="number"
                defaultValue="16"
              />
              <TextField
                id="standard-number"
                label="Memory (GB)"
                type="number"
                defaultValue="120"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AtlasPanel>
  );
};

export default DatasetAnalysis;
